import ThemeContextProvider from "../contexts/ThemeContextProvider";
import AuthContextProvider from "../contexts/AuthContextProvider";
import UserContextProvider from "../contexts/UserContextProvider";
import BranchContextProvider from "../contexts/BranchContextProvider";
import CategoryContextProvider from "../contexts/product/CategoryContextProvider";
import AddOnsContextProvider from "../contexts/product/AddOnsContextProvider";
import ProductContextProvider from "../contexts/product/ProductContextProvider";
import RoleContextProvider from "../contexts/RoleContextProvider";
import BranchProductContextProvider from "../contexts/branch_product/BranchProductContextProvider";
import BranchRequestProductContextProvider from "../contexts/branch_product/BranchRequestProductContextProvider";
import PromoContextProvider from "../contexts/PromoContextProvider";
import BranchRequestAddOnsContextProvider from "../contexts/branch_product/BranchRequestAddOnsContextProvider";
import BranchAddOnsContextProvider from "../contexts/branch_product/BranchAddOnsContextProvider";
import GlobalConfigContextProvider from "../contexts/GlobalConfigContextProvider";
import OrderContextProvider from "../contexts/order/OrderContextProvider";
import BranchOrderContextProvider from "../contexts/order/BranchOrderContextProvider";
import CustomerContextProvider from "../contexts/CustomerContextProvider";
import BannerContextProvider from "../contexts/BannerContextProvider";
import ReportContextProvider from "../contexts/ReportContextProvider";
import AnalyticsContextProvider from "../contexts/AnalyticsContextProvider";
import BranchReportContextProvider from "../contexts/BranchReportContextProvider";
import TableContextProvider from "../contexts/TableContextProvider";
import CateringSectionContextProvider from "../contexts/catering/CateringSectionContextProvider";
import CateringProductContextProvider from "../contexts/catering/CateringProductContextProvider";
import CateringMenuContextProvider from "../contexts/catering/CateringMenuContextProvider";
import CateringOrderContextProvider from "../contexts/catering/CateringOrderContextProvider";
import BranchCateringMenuContextProvider from "../contexts/branc_catering/BranchCateringMenuContextProvider";
import BranchCateringGlobalMenuContextProvider
    from "../contexts/branc_catering/BranchCateringGlobalMenuContextProvider";
import KitchenDisplayContextProvider from "../contexts/KitchenDisplayContext";
import PosOrderContextProvider from "../contexts/order/PosOrderContextProvider";
import IngredientCategoryContextProvider from "../contexts/ingredient_management/IngredientCategoryContextProvider";
import IngredientContextProvider from "../contexts/ingredient_management/IngredientContextProvider";
import BranchGlobalIngredientContextProvider
    from "../contexts/branch_ingredient_management/BranchGlobalIngredientContextProvider";
import RequestIngredientContextProvider from "../contexts/ingredient_management/RequestIngredientContextProvider";
import IngredientBranchContextProvider from "../contexts/branch_ingredient_management/IngredientBranchContextProvider";
import SupplierContextProvider from "../contexts/SupplierContextProvider";
import BranchSupplierContextProvider from "../contexts/BranchSupplierContextProvider";
import AgentContextProvider from "../contexts/agent/AgentContextProvider";
import StockTransactionContextProvider from "../contexts/stock/StockTransactionContextProvider";
import BranchConfigContextProvider from "../contexts/BranchConfigContextProvider";
import AgentPaymentContextProvider from "../contexts/agent/AgentPaymentContextProvider";
import FranchiseUserContextProvider from "../contexts/FranchiseUserContextProvider";


export const allProvider = [
    ThemeContextProvider,
    UserContextProvider,
    FranchiseUserContextProvider,
    BranchContextProvider,
    CategoryContextProvider,
    AddOnsContextProvider,
    ProductContextProvider,
    RoleContextProvider,
    BranchProductContextProvider,
    BranchRequestProductContextProvider,
    PromoContextProvider,
    BranchRequestAddOnsContextProvider,
    BranchAddOnsContextProvider,
    GlobalConfigContextProvider,
    BranchConfigContextProvider,
    OrderContextProvider,
    BranchOrderContextProvider,
    CustomerContextProvider,
    BannerContextProvider,
    ReportContextProvider,
    AnalyticsContextProvider,
    BranchReportContextProvider,
    TableContextProvider,
    CateringSectionContextProvider,
    CateringProductContextProvider,
    CateringMenuContextProvider,
    CateringOrderContextProvider,
    BranchCateringMenuContextProvider,
    BranchCateringGlobalMenuContextProvider,
    KitchenDisplayContextProvider,
    PosOrderContextProvider,
    IngredientCategoryContextProvider,
    IngredientContextProvider,
    BranchGlobalIngredientContextProvider,
    RequestIngredientContextProvider,
    IngredientBranchContextProvider,
    SupplierContextProvider,
    BranchSupplierContextProvider,
    AgentContextProvider,
    StockTransactionContextProvider,
    AgentPaymentContextProvider,
    AuthContextProvider,
];